<template>
    <div>
        <SearchableSelect v-if="!this.companyId" :items="companiesOptions" placeholder="Selecione uma empresa"
            @item-selected="selectCompany" />

        <SearchableSelect v-if="!this.instructionId && this.args.companyId" :items="instructionsOptions"
            placeholder="Selecione uma instrução trecho" @item-selected="selectinstruction" />

        <label v-if="this.companyId" class="col-form-label">Sistema de whatsapp</label>
        <SearchableSelect v-if="this.companyId" :items="whatsappSystemsOptions"
            placeholder="Selecione uma configuração de whatsapp" @item-selected="(value) => {args.whatsappSystemId = value}" />

        <div class="form-group">
            <div v-if="instruction?.assignor">
                <label for="assignees" class="col-form-label">Cedente</label>
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" :id="'assignee-' + instruction?.id"
                        :value="instruction.assignor?.id" v-model="args.sendAssignor">
                    <label :for="'assignee-' + instruction.id" class="form-check-label">
                        {{ instruction.assignor?.id }} - {{ instruction.assignor?.name }}
                    </label>
                </div>
            </div>

            <div v-if="instruction?.assignees">
                <label for="assignees" class="col-form-label">Cessionários</label>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="assigness" v-model="args.sendAllAssigness" />
                    <label class="form-check-label" for="assigness">
                        Enviar para todos
                    </label>
                </div>
                <div v-if="!args.sendAllAssigness" class="form-check">
                    <div v-for="assignee in instruction.assignees" :key="assignee.id">
                        <input type="checkbox" class="form-check-input" :id="'assignee-' + assignee.id"
                            :value="assignee.id" v-model="args.assignessList">
                        <label :for="'assignee-' + assignee.id" class="form-check-label">
                            {{ assignee.id }} - {{ assignee.name }}
                        </label>
                    </div>
                </div>
            </div>

            <div class="form-check">
                <div class="form-group">
                    <label for="additionalNotes" class="col-form-label">Mensagem</label>
                    <textarea class="form-control w-100" id="additionalNotes" v-model="args.body" rows="4"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchableSelect from '@/components/SearchableSelect.vue';
import { CompanyService, instructionService, whatsappSystemService } from '@/services/backend/ApiService';

export default {
    components: {
        SearchableSelect
    },
    props: {
        companyId: {
            type: String,
            required: false,
        },
        instructionId: {
            type: String,
            required: false
        },
        modelValue: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            companiesOptions: [],
            instructionsOptions: [],
            whatsappSystemsOptions: [],
            instruction: {},
            args: {
                companyId: null,
                instructionId: null,
                sendAllAssigness: false,
                sendAssignor: null,
                assignessList: [],
                body: String
            }
        };
    },
    async mounted() {
        if (!this.companyId) {
            this.companiesOptions = (await CompanyService.findAll()).map(value => {
                return {
                    option: `${value.id} - ${value.name}`,
                    value: value.id
                }
            })
        }

        if (this.modelValue) {
            this.args = this.modelValue;

            if (!this.modelValue.assignessList) {
                this.args.assignessList = [];
            }
        }

        this.initiateVariables()        
    },
    methods: {
        async initiateVariables() {
            this.instruction = await instructionService.findOne(this.instructionId);
            this.args.instructionId = this.instructionId;
            this.args.companyId = this.companyId;

            this.whatsappSystemsOptions = (await whatsappSystemService.findAll({ company: { id: this.args.companyId } })).map(value => {
                return {
                    option: `${value.id} - ${value.name}`,
                    value: value.id
                }
            }) || [];
        },
        async selectCompany(value) {
            this.args.companyId = value;
            this.args.instructionId = null;
            this.instructionsOptions = (await instructionService.findAll({ company: {id: value} })).map(value => {
                return {
                    value: value.id,
                    option: `${value.id} - ${value.name}`
                }
            });
        },
        async selectinstruction(value) {
            this.instruction = await instructionService.findOne(value);
            this.args.instructionId = value;
        }
    },
    watch: {
        modelValue(newValue) {
            this.args = newValue;
        },
        args: {
            handler(newValue) {
                this.$emit('update:modelValue', this.args);
            },
            deep: true,
        }
    }
};
</script>
